import { CustomAxiosRequestConfig } from "@xt/xtbase";
import axios from "utils/axios";

const BASE = "/xt-app/public/social-media-config";

const DEFAULT_TENANT_ID = "1";

export interface SocialMediaConfigItem {
  id: number;
  icon: string;
  name: string;
  linkUrl: string;
  category: number;
  weights: number;
}

function withTenantHeaders(config?: CustomAxiosRequestConfig): CustomAxiosRequestConfig {
  const tenantId = process.env.NEXT_PUBLIC_TENANT_ID ?? DEFAULT_TENANT_ID;
  return {
    ...config,
    headers: {
      "tenant-id": tenantId,
      ...config?.headers,
    },
  };
}

/** 客户端：社交媒体列表（仅启用项，按 weights 降序）。GET /xt-app/public/social-media-config/list */
export function get_socialMediaList(config?: CustomAxiosRequestConfig) {
  return axios.get(`${BASE}/list`, withTenantHeaders(config));
}

/** 客户端：社交媒体详情。GET /xt-app/public/social-media-config/{id} */
export function get_socialMediaDetail(id: number | string, config?: CustomAxiosRequestConfig) {
  return axios.get(`${BASE}/${id}`, withTenantHeaders(config));
}
